var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox styled"},[_c('input',{attrs:{"id":_vm.uid,"type":"checkbox","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.isChecked},on:{"click":_vm.onClick}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }